module.exports = __webpack_public_path__ + "static/moonteam_upper_body-d3b42d1147e7a5b1a32abb9849b00a84.jpg";